import Lenis from 'lenis'

import Common from 'js/_core/Common'
import { roundEx, lerp } from 'js/utils/Maths'
import { deepMerge } from 'js/utils/Utils'

const defaults = {
  instanceName: 'smoothScroll',
  options: {},
  diffLerp: 0.2,
}

export default class SmoothScroll {
  scrollDiff = 0
  scrollDiffLerp = 0

  currentScroll = 0
  lastScroll = 0

  isScrollingFixed = false

  constructor(options = {}) {
    deepMerge(this, defaults, options)
  }

  init() {
    this.manager = new Lenis(this.options)
    this.addHandler()
  }

  destroy() {
    this.removeHandler()
    this.manager.destroy()
  }

  start() {
    if (this.manager) {
      this.manager.start()
      this.scrollDiff = 0
      this.scrollDiffLerp = 0
    }
  }

  stop() {
    this.manager.stop()
    this.scrollDiff = 0
    this.scrollDiffLerp = 0
  }

  reset() {
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
    this.lastScroll = 0
    this.currentScroll = 0
  }

  addHandler() {
    if (Common.raf) {
      Common.raf.addHandler((time) => {
        this.onRaf(time)
      }, this.instanceName)
    }
  }

  removeHandler() {
    if (Common.raf) {
      Common.raf.removeHandler(this.instanceName)
    }
  }

  calcScrollDiff() {
    if (!Common.isScrollingFixed) {
      this.currentScroll = document.documentElement.scrollTop || document.body.scrollTop
      this.scrollDiff = roundEx(this.currentScroll - this.lastScroll, 10000)
      this.scrollDiffLerp = lerp(this.scrollDiffLerp, this.scrollDiff, this.diffLerp / Common.raf.fpsMultiplier)
      this.lastScroll = this.currentScroll
    }
  }

  onRaf(time) {
    this.manager.raf(time)
    this.calcScrollDiff()
  }
}